import { render, staticRenderFns } from "./NoRmMessageLabel.vue?vue&type=template&id=206a1859&"
import script from "./NoRmMessageLabel.vue?vue&type=script&lang=js&"
export * from "./NoRmMessageLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports